import { SVGProps, Ref, forwardRef } from 'react';

export const SpeakerWaveOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.089 12.854c1.466.976 2.2 1.464 2.72.91.522-.556.522-1.825.522-4.363V6.595c0-2.538 0-3.807-.521-4.362-.522-.555-1.255-.067-2.721.909L3.98 4.545q-.36.24-.682.456l-.3-.002C.375 4.999 0 5.374 0 7.998s.375 3 3 3q.153 0 .299-.003.32.217.682.456zM3.28 6.4l.437.006.363-.244.677-.452 2.107-1.403c.373-.248.672-.446.93-.605l.064-.04.014.138c.058.623.059 1.497.059 2.795v2.806c0 1.298-.001 2.172-.06 2.795l-.013.137-.065-.039a34 34 0 0 1-.929-.605l-2.107-1.403q-.362-.24-.677-.452l-.363-.244-.437.006-.28.001c-.646 0-1.05-.025-1.317-.075a1 1 0 0 1-.167-.041 1 1 0 0 1-.04-.166c-.05-.268-.076-.672-.076-1.317s.025-1.05.075-1.317q.023-.117.041-.166a1 1 0 0 1 .167-.04c.267-.051.67-.076 1.316-.076z"
                fill="currentColor"
            />
            <path
                d="m14.397 12.797-1.12-.84a6.57 6.57 0 0 0 1.319-3.959c0-1.485-.491-2.856-1.32-3.959l1.12-.84a7.96 7.96 0 0 1 1.6 4.799c0 1.8-.595 3.462-1.6 4.8"
                fill="currentColor"
            />
            <path
                d="M13.33 7.998c0 1.2-.397 2.308-1.066 3.2l-1.12-.84a3.9 3.9 0 0 0 .786-2.36c0-.885-.293-1.702-.786-2.36l1.12-.84a5.3 5.3 0 0 1 1.066 3.2"
                fill="currentColor"
            />
        </g>
    </svg>
));
SpeakerWaveOutlinedSize16Glyph.displayName = 'SpeakerWaveOutlinedSize16Glyph';
